import { render, staticRenderFns } from "./PaymentReport.vue?vue&type=template&id=4c51458b&scoped=true"
import script from "./PaymentReport.vue?vue&type=script&lang=js"
export * from "./PaymentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51458b",
  null
  
)

export default component.exports